<template>
  <div class="workflow-item-wrap">
    <div :class="'workflow-separator '+ (separatorClass)" v-if="needsSeparator"><span>{{ separatorText }}</span></div>
    <div :class="'list-group-item workflow-item' + (isDelivery ? ' workflow-delivery-item' : '') + (isNow ? ' workflow-status-now' : '') + (isPinned ? ' workflow-status-pinned' : '') + (isLate ? ' workflow-status-late' : '') " v-on:click="itemDetails(item)">
      <div class="label label-default label-xs workflow-date">{{ date }}</div>
      <div class="label label-default label-xs workflow-method" v-if="isDelivery">{{ deliveryMethodName }}</div>
      <div class="workflow-block workflow-order-tags">
        <span class="label label-primary label-xs workflow-order-tag" v-for="tag in orderTags">{{ getTagTitle(tag) }}</span>
      </div>
      <div class="workflow-block workflow-customer"><span class="customer-business" v-if="isBusinessCustomer">{{ companyName }}</span><span class="customer-client">{{ fullName }}</span></div>
      <div class="workflow-block workflow-products-resources">
        <span class="label label-default productname-hilite name-hilite" v-for="item in productNames">{{ item }}</span>
        <span class="label label-default resourcename-hilite name-hilite" v-for="item in resourceNames" v-html="formatResourceName(item)"></span>
        <span class="label label-default resourcename-hilite name-hilite" v-for="seat in seats"><i class="fa fa-fw fa-ticket"></i> {{ seat }}</span>
      </div>
      <div class="workflow-block workflow-status">
        <span class="label label-success label-xs" v-if="hasPaidLabel && order && parseInt(order.paid)">{{ _('Paid') }}</span>
        <span class="label label-warning label-xs" v-if="hasPaidLabel && order && !parseInt(order.paid)">{{ _('Not paid') }}</span>
        <span class="label label-success label-xs" v-if="hasProcessedLabel && parseInt(item.processed)">{{ _('Processed') }}</span>
        <span class="label label-danger label-xs" v-if="hasProcessedLabel && !parseInt(item.processed)">{{ _('Not processed') }}</span>
        <span class="label label-info label-xs" v-if="hasOpenOrderLabel && order && order.payment == 'open'">{{ _('Open order') }}</span>
        <span class="label label-default label-xs" v-if="hasConfirmedLabel && order && parseInt(order.confirmed) === 1">{{ _('Confirmed') }}</span>
        <span class="label label-default label-xs">{{ getDisplayedCount() }}</span>
        <span v-if="item.more || item.notes" class="label label-info label-xs" v-on:click.prevent.stop="displayNotes(order)"><i class="fa fa-fw fa-sticky-note"></i></span>
        <span class="label label-default label-xs workflow-footer-ordernumber">{{ _('Order') }} {{ orderNumber }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>

.workflow-item {
  background-color: white;
}
.workflow-customer span + span:before {
  content: ' / ';
}

</style>
<script>

import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import settingshelpers from '~/lib/settingshelpers'

export default {
  data () {
    return {
      minReasonableTimestamp: 1000000000
    }
  },
  props: ['item', 'mode', 'settings'],
  mixins: [settingshelpers],
  computed: {
    ...mapGetters(['locale', 'dateFormat', 'timeFormat', 'timezone']),
    hasPaidLabel () {
      return true
      // return this.mode === 'orders'
    },
    hasProcessedLabel () {
      return true
    },
    hasOpenOrderLabel () {
      return this.mode === 'orders'
    },
    hasConfirmedLabel () {
      return this.mode === 'orders'
    },
    date () {
      if (!this.item) {
        return ''
      }
      switch (this.mode) {
        case 'deliveries':
          if (!this.item.ts || parseInt(this.item.ts, 10) < this.minReasonableTimestamp) {
            return ''
          }
          return DateTime.fromSeconds(Number(this.item.ts), { zone: this.timezone }).toFormat(this.dateFormat + ' ' + this.timeFormat)
        default:
        case 'orders':
        if (!this.isFeatureEnabled('delivery2.0')) {
            return DateTime.fromSeconds(Number(this.item.orderdate), { zone: this.timezone }).toFormat(this.dateFormat + ' ' + this.timeFormat)
          }
          if (!this.item.delivery_ts || parseInt(this.item.delivery_ts, 10) < this.minReasonableTimestamp) {
            return ''
          }
          return DateTime.fromSeconds(Number(this.item.delivery_ts), { zone: this.timezone }).toFormat(this.dateFormat + ' ' + this.timeFormat)
      }
    },
    isDelivery () {
      return this.mode === 'deliveries'
    },
    needsSeparator() {
      // Joku saa koodata tämän sitten ns. oikeaan paikkaan, mutta holopainen pani sen nyt tänne
      return this.item && this.item.separator
    },
    separatorClass() {
      if (!this.needsSeparator) {
        return ''
      }
      switch (this.item.separator) {
        case 'late':
          return 'separator-late'
        case 'pinned':
          return 'separator-pinned'
        case 'normal':
          return 'separator-normal'
      }
    },
    separatorText() {
      if (!this.needsSeparator) {
        return ''
      }
      switch (this.item.separator) {
        case 'late':
          return this._('Late')
        case 'now':
          return this._('Now')
        case 'pinned':
          return this._('Pinned')
        case 'normal':
          return ''
      }
    },
    isNow () {
      return this.item && this.item.now
    },
    isPinned () {
      return this.item && parseInt(this.item.pinned)
    },
    isLate () {
      return this.item && this.item.late
    },
    order () {
      if (!this.item) {
        return null
      }
      return this.mode === 'orders' ? this.item : this.item.order
    },
    orderTags () {
      if (!this.order || !this.order.sharedTag || !this.order.sharedTag.length) {
        return []
      }
      return this.order.sharedTag
    },
    orderNumber () {
      return this.order ? this.order.id : ''
    },
    fullName () {
      if (!this.order) {
        return ''
      }
      return this.order.name ? this.order.name : (this.order.pos_name ? this.order.pos_name : this._('Transaction incomplete'))
    },
    companyName () {
      return this.order ? this.order.billing_company : ''
    },
    deliveryMethodName () {
      if (!this.settings || !this.settings.sharedDeliverymethod) {
        return ''
      }
      const deliveryMethod = this.settings.sharedDeliverymethod.find(dm => dm.id === this.item.deliverymethod_id)
      if (deliveryMethod) {
        return deliveryMethod.name
      }
      return ''
    },
    resourceNames () {
      return this.item.resourceNames ? this.item.resourceNames.split(';') : []
    },
    productNames () {
      return this.item.productNames ? this.item.productNames.split(';') : []
    },
    seats () {
      let ret = []
      if (this.item && this.item.ownItem) {
        this.item.ownItem.forEach((item) => {
          if (item.ownSeat) {
            item.ownSeat.forEach((seat) => {
              ret.push((seat.header ? seat.header + ' / ' : '') + seat.title)
            })
          }
        })
      }
      return ret
    },
    isBusinessCustomer () {
      return this.order && this.order.billing_company
    }
  },
  methods: {
    displayNotes (order) {
      this.EventBus.$emit('displayNotes', {
        type: 'order',
        transaction: order
      })
    },
    formatResourceName (item) {
      return item ? item.replace(/@checkedout$/, ' <i class="fa fa-fw fa-sign-out"></i>').replace(/@checkedin$/, ' <i class="fa fa-fw fa-sign-in"></i>') : ''
    },
    itemDetails (item) {
      this.$emit('itemDetails', item)
    },
    getTagTitle(tag) {
      if (!tag || !tag.title) {
        return ''
      }
      const parts = tag.title.split(':::')
      return parts.pop()
    },
    getDisplayedCount () {
      let displayedType = ''
      let totalCount = 0
      if (this.item && this.item.ownItem && this.item.ownItem.length > 0) {
        for (let i = 0; i < this.item.ownItem.length; i++) {
          if (!this.item.ownItem[i].reservation_count) {
            if (displayedType === 'participants') {
              displayedType = 'both'
            } else {
              displayedType = 'units'
            }
            totalCount += parseInt(this.item.ownItem[i].count, 10)
          } else {
            if (displayedType === 'units') {
              displayedType = 'both'
            }
            totalCount += parseInt(this.item.ownItem[i].reservation_count, 10)
          }
        }
        let suffix = ''
        switch(displayedType) {
          case 'units':
            suffix = ' ' + this._('pcs')
            break
          case 'participants':
            suffix = ' ' + this._('pers')
            break
        }
        return totalCount + suffix
      }
      return ''
    }
  }
}

</script>